import { useTranslation } from "react-i18next";
import { heroImage } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-background-50 pt-28 md:pt-40 pb-12 md:pb-20">
      <div className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute top-40 -left-24 h-72 w-72 rounded-full bg-accent-100/50 blur-3xl"></div>

      <div className="relative mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          {/* Text */}
          <div className="w-full">
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-100 px-4 py-1.5 text-xs font-semibold text-primary-700">
              <i className="ri-sparkling-line text-sm"></i>
              {t("hero.eyebrow")}
            </span>
            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
              {t("hero.title")}
            </h1>
            <p className="mt-5 max-w-xl text-base md:text-lg leading-relaxed text-foreground-600">
              {t("hero.subtitle")}
            </p>
            <p className="mt-4 max-w-xl text-sm md:text-base leading-relaxed text-foreground-500">
              {t("hero.support")}
            </p>

            <div className="mt-7 flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
              >
                {t("buttons.usfansSpreadsheet")}
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
              >
                {t("buttons.buyNow")}
                <i className="ri-external-link-line text-base"></i>
              </a>
            </div>

            <p className="mt-6 flex items-center gap-2 text-xs md:text-sm font-medium text-foreground-500">
              <i className="ri-shield-check-line text-primary-600 text-base"></i>
              {t("hero.trust")}
            </p>
          </div>

          {/* Image */}
          <div className="w-full">
            <div className="relative overflow-hidden rounded-2xl">
              <div className="h-[280px] md:h-[420px] w-full">
                <img
                  src={heroImage}
                  alt="USFans Spreadsheet product research and organized product categories"
                  title="USFans Spreadsheet product research"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3 rounded-xl bg-background-50/90 p-4 backdrop-blur">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className="ri-stack-line text-lg"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t("cat.title")}</p>
                  <p className="text-xs text-foreground-500">{t("hero.trust")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}